import React from 'react';
import { FormattedMessage } from 'react-intl';
import config from 'appconfig';
import { StyledLink } from '../StyledComponents';
import { StyledPipe } from './StyledPipe';

export const RenewLink = ({ accountId }: { accountId: number }) => (
  <>
    <StyledLink
      href={`${config.root}/renew?accountId=${accountId}`}
      data-cy="actions-section-renew-button"
    >
      <FormattedMessage id="mac.licenses.renew" defaultMessage="Renew" />
    </StyledLink>
    <StyledPipe />
  </>
);
